import axios, { AxiosResponse } from 'axios'

import { isProductionEnv } from '../../../utils/env'
import { SignAccountRes } from './interfaces/sign-account.interface'
import { SignTaskReq, SignTaskRes } from './interfaces/sign-task.interface'
import { ITask } from './interfaces/task.interface'
import { ITwitter } from './interfaces/twitter.interface'

axios.defaults.baseURL = isProductionEnv() ? `${process.env.REACT_APP_API_URL}/api` : '/api'

axios.interceptors.response.use(async (response) => {
  return response
})

const responseBody = <T>(response: AxiosResponse<T>) => response.data

const requests = {
  get: <T>(url: string, params: Record<string, any>) => axios.get<T>(url, { params }).then(responseBody),
  post: <T>(url: string, body: any) => axios.post<T>(url, body).then(responseBody),
  put: <T>(url: string, body: any) => axios.put<T>(url, body).then(responseBody),
  delete: <T>(url: string) => axios.delete<T>(url).then(responseBody),
}

const competition = {
  isRegistered: (account: string) => {
    const res = requests.post<{ registered: boolean }>(`/auth/check`, {
      account,
    })
    return res
  },
  signAccount: (account: string, timestamp: string, signature: string) => {
    const res = requests.post<SignAccountRes>(`/auth/sign`, {
      account,
      timestamp,
      signature,
    })
    return res
  },
  callback: (code: string, state: string) => {
    const res = requests.get<ITwitter>(`/auth/twitter/callback`, { code, state })
    return res
  },
  signTask: (account: string, payload: SignTaskReq, signature: string) => {
    const res = requests.post<SignTaskRes>(`/tasks/sign`, {
      account,
      payload,
      signature,
    })
    return res
  },
  createTask: (data: any) => {
    const res = requests.post<SignTaskRes>(`/tasks`, data)
    return res
  },
  getTasks: () => {
    const res = requests.get<ITask[]>(`/tasks`, {})
    return res
  },
  getTasksByWallet: (wallet: string) => {
    const res = requests.get<ITask[]>(`/tasks/by_wallet/${wallet}`, {})
    return res
  },
  confirmTask: (data: { id: number; wallet: string }) => {
    const res = requests.post<SignTaskRes>(`/tasks/confirm`, data)
    return res
  },
  // getPreviewsData: (addresses: string[]) =>
  //   requests.post<PresalePreviewsStaticData>('/presale/previews', {
  //     addresses,
  //   }),
  // finalizePresale: (address: string) =>
  //   requests.post<string>('/presale/finalize', {
  //     address,
  //   }),
  // create: (data: PresalePostData) => requests.post<PresaleStaticData>('/presale', data),
  // update: (data: PresalePostData) => requests.put<PresaleStaticData>(`/presale/${data.address}`, data),
  // delete: (address: string) => requests.delete<PresaleStaticData>(`/presale/${address}`),
}

export const agent = {
  competition,
}
